import preloadedTranslations from "../locales/preloadedTranslations.json";

const sortZoneValues = (zones) => {
  // Create a copy of the array to avoid mutating the original
  return [...zones].sort((a, b) => {
    // Extract the number after "zone-" and compare numerically
    const numA = parseInt(a.split("-")[1], 10);
    const numB = parseInt(b.split("-")[1], 10);
    return numA - numB;
  });
};

const getDistinctValues = (obj, key) => {
  // Create a Set to store distinct sizes
  const distinctSet = new Set();

  // Loop through the items and add unique sizes to the Set
  obj.forEach((item) => {
    distinctSet.add(item[key]);
  });

  // Convert the Set back to an array
  const distinctValues = Array.from(distinctSet);

  return distinctValues;
};

function getRandomValue() {
  const array = new Uint8Array(1);
  window.crypto.getRandomValues(array);
  return array[0] % 16;
}

const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    //  const r = (Math.random() * 16) | 0;
    const r = getRandomValue();
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const selectAllValues = (arr) => {
  const obj = {};
  arr.map((val) => {
    obj[val] = true;
  });
  return obj;
};

const unSelectAllValues = (arr) => {
  const obj = {};
  arr.map((val) => {
    obj[val] = false;
  });
  return obj;
};

const mergeTranslations = () => {
  const translations = JSON.parse(localStorage.getItem("translations")) || {};

  const mergedTranslations = {};

  for (const language in translations) {
    mergedTranslations[language] = {
      ...translations[language],
      ...preloadedTranslations[language],
    };
  }

  for (const language in preloadedTranslations) {
    if (!mergedTranslations[language]) {
      mergedTranslations[language] = {
        ...translations[language],
        ...preloadedTranslations[language],
      };
    }
  }

  localStorage.setItem("translations", JSON.stringify(mergedTranslations));
};

// get site status transactions from api
const getSiteStatusTransactions = async (authToken, callback) => {
  const url =
    process.env.REACT_APP_API_BASE_URL + `/get_site_status_transactions`;

  fetch(url, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // Process the retrieved data here
      callback(data);
    })
    .catch((error) => {
      // Handle any errors that occurred during the request
      console.error("Error: Something went wrong");
    });
};

function formatDate(inputDateString) {
  try {
    // Split the input date string by spaces and dots
    const parts = inputDateString.split(/[\s.]+/);

    // Define an array of month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Extract date components
    const day = parts[0].padStart(2, "0");
    const month = monthNames[parseInt(parts[1], 10) - 1];
    const year = parts[2];
    const timeParts = parts[3].split(":");
    let hours = parseInt(timeParts[0].padStart(2, "0"));
    const minutes = timeParts[1].padStart(2, "0");
    const seconds = (timeParts[2][0] + timeParts[2][1]).padStart(2, "0");
    const meridian = hours === 12 ? "PM" : hours < 12 ? "AM" : "PM";

    if (hours == 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    hours = hours.toString().padStart(2, "0");

    // Format the date in the desired output format
    const formattedDate = `${day} ${month} ${year} ${hours}:${minutes}:${seconds} ${meridian}`;

    return formattedDate;
  } catch (error) {
    console.error("formatDate error");
    return inputDateString;
  }
}

const saveReportUsingAPI = async (authToken, data, callback) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `/get_consolodated_report?delivery_number=${data.delivery_number}&zone=${data.zone}&email_id=${data.email_id}&size=${data.size}`;

  fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // Process the retrieved data here
      callback(data, null);
    })
    .catch((error) => {
      // Handle any errors that occurred during the request
      console.error("Error: Something went wrong");
      callback(null, error);
    });
};

function countTrueValues(obj) {
  return Object.values(obj).reduce(
    (count, value) => count + (value === true ? 1 : 0),
    0
  );
}

function getAverage(str) {
  const numbers = str.match(/\d+/g);

  if (numbers === null) {
    return 0;
  }

  const intNumbers = numbers.map(Number);

  const avg = intNumbers.reduce((a, b) => a + b, 0) / intNumbers.length;

  return avg;
}

function sortDistinctSizeValues(sizes) {
  const sortedRanges = sizes.sort((a, b) => getAverage(a) - getAverage(b));

  console.log(sortedRanges);
  return sortedRanges;
}
const selectAll = (value, valueArray, selectAllOptions) => {
  const newStatus = value[selectAllOptions];
  const selectObj = valueArray.reduce((obj, size) => {
    obj[size] = !newStatus;
    return obj;
  }, {});
  return selectObj;
};

function countWorkerAssignments(sites) {
  const workerCount = {};

  sites.forEach((site) => {
    const assigned = site["Assigned Employee"];
    const status = site["status"];
    if (status !== "new" && assigned && assigned !== "NA") {
      const parts = assigned.split("--");
      if (parts.length === 2) {
        const workerId = parts[1].trim();
        workerCount[workerId] = (workerCount[workerId] || 0) + 1;
      }
    }
  });

  return workerCount;
}

const helperFunctions = {
  sortZoneValues: sortZoneValues,
  selectAll: selectAll,
  getDistinctValues: getDistinctValues,
  selectAllValues: selectAllValues,
  generateUUID: generateUUID,
  mergeTranslations: mergeTranslations,
  getSiteStatusTransactions: getSiteStatusTransactions,
  formatDate: formatDate,
  saveReportUsingAPI: saveReportUsingAPI,
  countTrueValues: countTrueValues,
  sortDistinctSizeValues: sortDistinctSizeValues,
  unSelectAllValues: unSelectAllValues,
  countWorkerAssignments: countWorkerAssignments,
};

export default helperFunctions;
